var WDN = WDN || {};

if (typeof WDN.MobileMenu === "undefined") {
  WDN.MobileMenu = (function () {
    var init;
    var onCartClick, onCountryClick, onMenuCartClick;

    // Depends on
    var SectionRenderer = WDN.SectionRenderer;

    // Returned instances
    var Renderer, Slides;

    // Nodes
    var nodes = {
      cartTrigger: false,
    };

    // Country not set up in localization: stay on the page, like the drawer does
    onCountryClick = function (e) {
      if (this.hasAttribute("data-close-drawer")) {
        e.preventDefault();
        return;
      }
      WDN.CountrySelect.onLinkClick.call(this, e);
    };

    // Same trigger as the header's cart icon, so the menu closes and the drawer loads as usual
    onMenuCartClick = function (e) {
      var trigger = document.querySelector(".header wdn-drawer-open[data-id='cart']");
      if (!trigger) return;
      e.preventDefault();
      trigger.click();
    };

    // Handles cart trigger click inside mobile menu
    onCartClick = function () {
      WDN.CartDrawer.refresh();
      nodes.cartTrigger.removeEventListener("click", onCartClick);
    };

    init = function () {
      Renderer = new SectionRenderer({
        selectors: {
          trigger: "wdn-drawer-open[data-id='menu']",
          output: "[data-mobilemenu-content]",
        },
        sections: ["async-mobile-menu"],
        events: ["click"],
        callback: function () {
          // Setup of slides
          WDN.MobileMenu.Slides = new WDN.Slides({
            group: "mobilemenu",
          });

          // Setup of country select
          if (!WDN.CountrySelect.Renderer.complete) {
            WDN.CountrySelect.Renderer.reinit();
          }

          // Countries on the menu's "Shipping to" page redirect like the country drawer
          document
            .querySelectorAll("[data-slide='shipping-country'] [data-code]")
            .forEach(function (link) {
              link.addEventListener("click", onCountryClick);
            });

          // A menu link to the cart opens the cart drawer (falls back to the cart page)
          var cartLink = document.querySelector("[data-mobilemenu-content] [data-menu-cart]");
          if (cartLink) cartLink.addEventListener("click", onMenuCartClick);
        },
      });

      // Callback to SectionRenderer - fired before the request is sent
      Renderer.onInteraction = function () {
        // Load stylesheet
        WDN.StylesheetLoader.load(".mobilemenu-style");
      };

      // Listen for drawer close
      document.body.addEventListener("overlay:closed", function (e) {
        if (e.detail.id !== "menu") return;
        // Select back arrow
        var backArrow = document.querySelector("[data-slide-to='back'][data-slide-group='mobilemenu']");

        // Select scroll container inside the drawer
        var scrollableContent = document.querySelector("[data-menu-scroll]");

        // Slide back to initial state (400ms delay for animation to finish)
        setTimeout(function () {
          // Set scroll position to top
          if (scrollableContent) {
            scrollableContent.scroll(0, 0);
          }

          // Reset slides positions by clicking first back arrow
          if (backArrow) {
            backArrow.click();
          }
        }, 400);
      });
    };

    // Init
    init();
    return {
      Renderer,
      Slides,
    };
  })();
}
